import * as THREE from 'three';

/**
 * True glass for balcony Plane.* panes (window glazing in the GLB).
 * Transmission supported on MeshPhysicalMaterial in three@0.143.
 */
export function createGlassMaterial() {

  // Soft glass without SSR/transmission ghosting when orbiting the camera.
  // Env reflections only — no screen-space trail.
  const mat = new THREE.MeshPhysicalMaterial({

    color: 0xd8eaf8,
    metalness: 0,
    roughness: 0.12,
    transmission: 0,
    transparent: true,
    opacity: 0.22,
    envMapIntensity: 0.55,
    clearcoat: 0.4,
    clearcoatRoughness: 0.15,
    side: THREE.DoubleSide,
    depthWrite: false,

  });

  mat.userData.isConstructorMaterial = true;
  mat.userData.isGlass = true;

  return mat;

}

export function isGlassMeshName( name = '' ) {

  return /^Plane(\.\d+)?$/i.test( name ) || name.toLowerCase().indexOf( 'glass' ) !== -1;

}
